import { Customization } from '@/types/recommendation'
import { api } from './api'
import { PutSelfAssessmentPayload } from '@/api/assessment'
import { RecommendationProductFile } from '@/pages/PublicCheckoutPage/steps/PublicCheckoutOverviewStep'

export type SearchCriteria = {
  approxTurnover: number | null
  fullTimeEmployeesCount: number | null
  miniJobbersCount: number | null
  partTimeEmployeesCount: number | null
  ownersCount: number | null
  salary: number | null
  startDate: string | null
  paymentPeriod: 'yearly' | 'half-yearly' | 'quarterly' | 'monthly'
  businessType: string[]
  businessTypeOtherSpecification: string | null
  amountInsured: string | null
  deductible: string | null
  options: {
    name: string
    value: boolean
  }[]
}

export interface GetRecommendationByIdApiResponse {
  categoryId: string
  createdAt: string
  isSearchable?: boolean
  isLocked?: boolean
  searchCriteria?: SearchCriteria
  companyFoundedDate?: string | null
  visibleAttributes: string[]
  bestChoice: string
  locationId: string
  partnerSource: string | null
  recommendationId: string
  relatedRecommendationIds?: string[]
  recommendationProducts: {
    name: string
    categoryId: string
    amountInsured: number
    deductible: number
    recommendationProductId: string
    parametersValues: {
      de: Record<string, string>
      en: Record<string, string>
    }
    yesNoValues: Record<string, 0 | 1>
    grossPrice: number
    paymentPeriod: string
    carrierId: string
    carrierData: {
      logoUrl: string
      name: string
    }
    discountValue: number
    recommendationProductFiles: RecommendationProductFile[]
    amountInsuredUnlimited: boolean
    offerTag?: string | null
    order: number
    status: 'success' | 'error' | null
    isSearchEnginePrice: boolean | null
  }[]
  customization?: Customization
}

interface RequestRecommendationResponse {
  recommendationId: string
}

interface ResetRecommendationResponse {
  success: boolean
}

export const getRecommendationById = (
  id: string,
): Promise<GetRecommendationByIdApiResponse> =>
  api.get(`/user/recommendation/${id}`)

export const requestRecommendation = ({
  categoryId,
  locationId,
  partnerSource,
  message,
  assessment,
}: {
  categoryId: string
  locationId: string
  partnerSource: string | null
  message?: string
  assessment?: PutSelfAssessmentPayload
}): Promise<RequestRecommendationResponse> =>
  api.post('/user/recommendation', {
    categoryId,
    locationId,
    partnerSource,
    message,
    assessment,
  })

export const updateRecommendationOptions = ({
  recommendationId,
  amountInsured,
  paymentPeriod,
  deductible,
  options,
}: {
  recommendationId: string
  paymentPeriod?: string
  amountInsured?: string
  deductible?: string
  options?: { name: string; value: boolean }[]
}): Promise<RequestRecommendationResponse> =>
  api.patch(`/user/recommendation/${recommendationId}`, {
    searchCriteria: {
      ...(amountInsured && { amountInsured }),
      ...(paymentPeriod && { paymentPeriod }),
      ...(deductible && { deductible }),
      ...(options && { options }),
    },
  })

export const resetRecommendationOptions = ({
  recommendationId,
}: {
  recommendationId: string
}): Promise<ResetRecommendationResponse> =>
  api.post(`/user/recommendation/${recommendationId}/reset-customization`)
